window.dataLayer = window.dataLayer || [];

export function trackEvent(event, params = {}) {
  window.dataLayer.push({ event, ...params });
}

export function initClickTracking() {
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-track]');
    if (el) {
      trackEvent(el.dataset.track, {
        label: el.dataset.trackLabel || el.textContent?.trim()?.slice(0, 80),
        href: el.href || el.dataset.href,
      });
    }
    const link = e.target.closest('a[href^="tel:"]');
    if (link) trackEvent('phone_click', { phone: link.href.replace('tel:', '') });
    const mail = e.target.closest('a[href^="mailto:"]');
    if (mail) trackEvent('email_click', { email: mail.href.replace('mailto:', '') });
    const wa = e.target.closest('a[href*="wa.me"], a[href*="whatsapp"]');
    if (wa) trackEvent('whatsapp_click', { href: wa.href });
  });
}

export function trackPurchase(orderData = {}) {
  trackEvent('purchase', {
    transaction_id: orderData.transactionId || orderData.orderId,
    value: orderData.value || orderData.total,
    currency: orderData.currency || 'EUR',
  });
}

export function trackLead(type, data = {}) {
  trackEvent('lead', { lead_type: type, ...data });
}
